import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Form from './src/components/Form';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession, Auth, getCurrentUser } from '@aws-amplify/auth';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsconfig from './src/aws-exports'; // Esto contiene tu configuración de Amplify
import Indicators from './src/components/Indicators';
//QUEDO SIN ANDAR NO PUEDO HACER EL SIGNIN
Amplify.configure({
  ...awsconfig,
  ssr: true,
});


export default function App() {
  const [token, setToken] = useState(null); // Estado para manejar el token
  const [user, setUser] = useState(null);

  // Función para obtener el token
  //@fixme agregar llamado a get_user_profile
  const fetchToken = async () => {
    try {
      const session = await fetchAuthSession();//fetchAuthSession();

      const idToken = session.tokens ? session.tokens.idToken.toString() : null;
      const accessToken = session.tokens ? session.tokens.accessToken.toString() : null
      // const idToken = session.idToken.jwtToken; // ID Token
      // const accessToken = session.accessToken.jwtToken; // Access Token
      setToken(idToken); // Puedes almacenar el token que prefieras
      // console.log('Tokens obtenidos:', { idToken, accessToken });
      const response = await fetch("https://panel.apis.rotomlabsapis.com/onepanel/get_user_profile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization:idToken//"eyJraWQiOiJBUjM5U3NcL3BcL2NvTjB0eWJ2TlNzSGtnR25PdkRwTEg3d2dFZEpDRTZic2M9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIxMTliMzUyMC1iMGMxLTcwMzMtYTEwMS1iODM1MjEzODBlNjMiLCJkZXZpY2Vfa2V5IjoidXMtZWFzdC0yXzZlM2U2MDk2LTYxNWEtNDEzYS1iYzhjLTIwMjc3NDkxYmYzYiIsImNvZ25pdG86Z3JvdXBzIjpbIm9uZV9kb3RzIl0sImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0yX3JDTmhEUXNHbSIsImNsaWVudF9pZCI6IjU3OW04aWRtZTg5dWxmczcyOXVnOHA1NXV0Iiwib3JpZ2luX2p0aSI6ImY5ZjgzYjkwLWVjNGYtNGUxNi1iYjlkLWNiNmRkZWQ0YzJkMSIsImV2ZW50X2lkIjoiYTAxNWIyMWEtZDMwOS00MWQzLWE5M2QtZTNjOGQ1OWRhODc0IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTcyNzg4ODAxMSwiZXhwIjoxNzI3ODkxNjExLCJpYXQiOjE3Mjc4ODgwMTEsImp0aSI6ImI4ODVjOTI2LTdkYjItNDIxYi1iYzRkLWIwMjBkYzg5MTExNSIsInVzZXJuYW1lIjoiZG90c190ZXN0X2ltcG9ydGFkb3JAZG90cy5jb20ifQ.wSjqV3Pu_hCmjlokTahq3F1_0jozpNMuDzd6bmKZ6oLMW8CfE6-PjDllCo7AQLoX16d_D-pPLWcXJKW5IsaaN1Mxnr_unurxfaWfOnGRG0f88-MRITVs2ipDiX9RxhAZ20-emsWm1YBDAzYFGIoBdC08r8WuAktXBM5DZU3PnZXVi0PluCnJ6UvZve9LGjdhxYX_h1OoKXW-t-cK9TRrbzpOXc_kFsBUvkbzhuJgEgSml3dtLYRGYx8yhvMVHRek037DM15Ohxg13xEgDwGAlOhto0-HqdjNkyeuH2S14CoV2ViEMfk-Wwf_0qw7AcQCIgWrBpF54Ks2pqEIJ4JNtA"
        },
      });
      const data = await response.json();
      // console.log('Data:', data);
      if(data.status == -1){
        setTimeout(() => {
          window.location.href = "https://prod.dotspanel.com/"; // Cambia esto por la URL deseada
      }, 2000);
      }
    } catch (error) {
      console.error('Error al obtener el token:', error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchToken();
    }
  }, [user]);

  return (
    <Authenticator.Provider>
      <Authenticator hideSignUp>
        {({ signOut, user: authenticatedUser }) => {
          if (!user && authenticatedUser) {
            setUser(authenticatedUser);
          }

          return user ? (
            <Router>
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <Form user={user} />
                      <button onClick={signOut}>Sign out</button>
                    </>
                  }
                />
                <Route path="/indicadores" element={<Indicators />} />
              </Routes>
            </Router>
          ) : (
            <div>
              <h1>Redirigiendo al flujo de inicio de sesión...</h1>
            </div>
          );
        }}
      </Authenticator>
</Authenticator.Provider>
  );
}
